import {Button} from '../Footer'

function Modify({setPage}) {
    return <></>
    return <>
        <Button onClick={() => setPage('menu')}>Modify my order</Button>
        <br />
        <p>
            You can modify your order until 7:00 AM
        </p>
    </>
}

export default Modify;
